"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HiddenFilterBar = void 0;
/**
 * This implementation of Filter Bar will ensure that all the filter controls are out of sight. All the dashboard
 * filtering is still in place however user cannot see or interact with the filters.
 *
 * @alpha
 */
exports.HiddenFilterBar = function (_props) {
    return null;
};
//# sourceMappingURL=HiddenFilterBar.js.map